// Libraries
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Parent } from '../../../../models/Parent';
import { NonAisParent } from '../../../../../common/modules/user/models/NonAisParent';
import { Credential } from '../../../../../common/modules/user/models/Credential';
import { RegisterService } from '../../../../../common/modules/user/services/RegisterService';
import { HolidayService } from '../../../../services/HolidayService';
import { NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { FormGroupDirective } from '@angular/forms';
import { ViewChild } from '@angular/core';

@Component({
    selector: 'add-parent',
    template: require('./AddParentComponent.html'),
    styles:[require('./AddParentComponent.sass')]
})
export class AddParentComponent implements OnInit {
    private nonAisParent: NonAisParent;
    private nonAisParent2: NonAisParent;
    private credential: Credential;
    private formSubmitted: boolean = false;
    private message: string;
    private messageType: string;
    private message2: string;
    private messageType2: string;
    private parentDetail: Parent;
    private EDIT_PROFILE_PAGE = 'edit-parent';
    private isEditProfile: boolean = false;
    public msgs: any[];

    @ViewChild('registerNonAisForm') registerNonAisForm: FormGroupDirective;
    @ViewChild('registerNonAisForm1') registerNonAisForm1: FormGroupDirective;

    constructor(
        private router: Router,
        private registerService: RegisterService,
        private holidayService: HolidayService
    ) {
        this.parentDetail = new Parent();
        this.router.events.filter(evt => evt instanceof NavigationEnd)            
        .subscribe((event) => {
            if (event['url'].indexOf(this.EDIT_PROFILE_PAGE) > -1) {
                this.isEditProfile = true;
            }
        });
    }
    
    ngOnInit() {
        this.nonAisParent = new NonAisParent();
        this.getParent();
    }

    onSubmitNonAis() {
       
        this.credential = new Credential('hol-parent', '', '');
        this.formSubmitted = true;
        // Reset message content
        this.message = "";
        // Post user login data to create session
        if(this.isEditProfile)
            this.updateProfile(this.parentDetail);
        else
            this.registerNonAis(this.nonAisParent);
    }

    private updateProfile(parentDetail: any){
        if(!this.validateForm()){
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error', detail: 'Please fill required fields!' });
            return;
        }
        
        if (parentDetail.hol_parent_details.length < 2)
            parentDetail.hol_parent_details.push(this.nonAisParent);
        if (parentDetail.hol_parent_details[0].email == parentDetail.hol_parent_details[1].email)
            return;

        let listObservables: any = [];

        for (let parent of parentDetail.hol_parent_details) {
            listObservables.push(this.registerService.updateParent(parent));
        }

        Observable.forkJoin(listObservables).subscribe(data => {
            this.msgs = [];
            this.msgs.push({ severity: 'success', summary: 'Success', detail: 'Update profile success!' });
            setTimeout(() => {
                if (this.parentDetail.holStudents.length > 1) {
                    this.router.navigateByUrl('/booking/students');
                }
                else {
                    this.router.navigateByUrl('/add-student');
                }
            }, 2000);
            
        }, error => {
            this.messageType = "alert";
            this.message = "Update Error";
            this.formSubmitted = false;
        });
    }

    private registerNonAis(nonAisParent: NonAisParent) {
        if(this.parentDetail.hol_parent_details[0].email == this.nonAisParent.email)
            return;
            
        this.registerService.updateParent(nonAisParent)
            .subscribe(
                complete => {
                    this.messageType = "success",
                    this.message = "Adding Successfully";
                    this.formSubmitted = false;
                    console.log(this.parentDetail)
                    if(this.parentDetail.holStudents.length > 1) {
                        this.router.navigateByUrl('/booking/students');
                    }
                    else {
                        this.router.navigateByUrl('/add-student');
                    }
                },
                error => {
                    this.messageType = "alert";
                    this.message = "Adding Error";
                    this.formSubmitted = false;
                }
            );
    }

    private getParent() {
        this.holidayService.getParent()
            .subscribe(
                parent => {
                    this.parentDetail = parent;
                    console.log(this.parentDetail)
                },
                error => {
                    //TO DO: Handle any error if needed in the furture
                    this.message     = "";
                    this.messageType = "alert";
                }
            );
    }

    validateForm(){
        if (this.parentDetail.hol_parent_details.length < 2){
            if(this.registerNonAisForm.form.valid && this.registerNonAisForm1.form.valid)
                return true;
            else
                return false;
        }
        else{
            if(this.registerNonAisForm.form.valid)
                return true;
            else
                return false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/holiday/parent/profile/parent/add-parent/AddParentComponent.ts